import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import {ListItem} from "src/app/entities/list-item.entity";
import ReducedUser = Backend.App.Resources.Dashboard.Administration.ReducedUser;
import ReducedUserData = Backend.App.Data.Dashboard.Administration.ReducedUserData;

@Injectable({providedIn: 'root'})
export class UserService extends BaseEndpointService<ReducedUser, ReducedUserData> {
  protected override endpoint = '/administration/users';

  public override modelToMultiSelectItem(m: ReducedUser): ListItem & { model: ReducedUser; } {
    return {
      id: m.id,
      text: m.name,
      isDisabled: false,
      model: m,
    }
  }
}
